// src/pages/processifyd/ProcessifydStateTransitions.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faFolderOpen,
  faSearch,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faList,
  faDownload
} from "@fortawesome/free-solid-svg-icons";

const ProcessifydStateTransitions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [transitions, setTransitions] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 8;

  const [showModal, setShowModal] = useState(false);
  const [editingTransition, setEditingTransition] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [loading, setLoading] = useState(false);
  
  const initialForm = {
    transitionType: "Manual",           // Default as per your example
    transitionFromState: "",
    transitionToState: "",
    stateTransitionRemarks: "",
    processName: "",                    // Reference to Process (e.g. CSAT Program Management Process)
    clientName: "",
    active: "Yes",
  };

  const [formData, setFormData] = useState(initialForm);

  // Sample Demo Data
  const demoTransitions = [
  {
    id: 1,
    transitionType: "Automatic",
    transitionFromState: "New Survey Created",
    transitionToState: "Survey Distribution Initiated",
    stateTransitionRemarks: "New Survey Created → Survey Distribution Initiated",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:30",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:30",
  },
  {
    id: 2,
    transitionType: "Automatic",
    transitionFromState: "Survey Distribution Initiated",
    transitionToState: "Survey Distribution in Progress",
    stateTransitionRemarks: "Survey Distribution Initiated → In Progress",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:31",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:31",
  },
  {
    id: 3,
    transitionType: "Automatic",
    transitionFromState: "Survey Distribution in Progress",
    transitionToState: "Survey Distribution Finished",
    stateTransitionRemarks: "Survey Distribution In Progress → Finished",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:32",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:32",
  },
  {
    id: 4,
    transitionType: "Manual",
    transitionFromState: "Survey Distribution in Progress",
    transitionToState: "Survey Abandoned",
    stateTransitionRemarks: "Survey abandoned during distribution",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:33",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:33",
  },
  {
    id: 5,
    transitionType: "Automatic",
    transitionFromState: "Survey Distribution Finished",
    transitionToState: "Feedback Collection in Progress",
    stateTransitionRemarks: "Distribution finished → Start feedback collection",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:34",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:34",
  },
  {
    id: 6,
    transitionType: "Automatic",
    transitionFromState: "Feedback Collection in Progress",
    transitionToState: "New Feedback Received",
    stateTransitionRemarks: "Customer feedback received",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:35",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:35",
  },
  {
    id: 7,
    transitionType: "Automatic",
    transitionFromState: "New Feedback Received",
    transitionToState: "Response Followup Preparation Initiated",
    stateTransitionRemarks: "Prepare follow-up response",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:36",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:36",
  },
  {
    id: 8,
    transitionType: "Automatic",
    transitionFromState: "New Feedback Received",
    transitionToState: "Feedback Validated",
    stateTransitionRemarks: "Feedback validated directly",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:37",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:37",
  },
  {
    id: 9,
    transitionType: "Automatic",
    transitionFromState: "Response Followup Preparation Initiated",
    transitionToState: "Response Followup Communication in Progress",
    stateTransitionRemarks: "Follow-up communication started",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:38",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:38",
  },
  {
    id: 10,
    transitionType: "Automatic",
    transitionFromState: "Response Followup Communication in Progress",
    transitionToState: "Response Followup Communication Finished",
    stateTransitionRemarks: "Follow-up completed",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:39",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:39",
  },
  {
    id: 11,
    transitionType: "Automatic",
    transitionFromState: "Response Followup Communication Finished",
    transitionToState: "Feedback Validated",
    stateTransitionRemarks: "Feedback validated after follow-up",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:40",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:40",
  },
  {
    id: 12,
    transitionType: "Automatic",
    transitionFromState: "Feedback Validated",
    transitionToState: "Feedback Collection Finished",
    stateTransitionRemarks: "All feedback validated → collection finished",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:41",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:41",
  },
  {
    id: 13,
    transitionType: "Automatic",
    transitionFromState: "Feedback Collection Finished",
    transitionToState: "Feedback Analysis Initiated",
    stateTransitionRemarks: "Start analysis phase",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:42",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:42",
  },
  {
    id: 14,
    transitionType: "Manual",
    transitionFromState: "Feedback Collection Finished",
    transitionToState: "Survey Abandoned",
    stateTransitionRemarks: "Survey abandoned after collection",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:43",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:43",
  },
  {
    id: 15,
    transitionType: "Automatic",
    transitionFromState: "Feedback Collection Finished",
    transitionToState: "CSAT Report Initiated",
    stateTransitionRemarks: "Start CSAT reporting",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:44",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:44",
  },
  {
    id: 16,
    transitionType: "Automatic",
    transitionFromState: "Feedback Analysis Initiated",
    transitionToState: "Feedback Analysis in Progress",
    stateTransitionRemarks: "Analysis started",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:45",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:45",
  },
  {
    id: 17,
    transitionType: "Automatic",
    transitionFromState: "Feedback Analysis in Progress",
    transitionToState: "Feedback Analysis Done",
    stateTransitionRemarks: "Analysis completed",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:46",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:46",
  },
  {
    id: 18,
    transitionType: "Automatic",
    transitionFromState: "Feedback Analysis Done",
    transitionToState: "Rating Aggregation Initiated",
    stateTransitionRemarks: "Start rating aggregation",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:47",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:47",
  },
  {
    id: 19,
    transitionType: "Automatic",
    transitionFromState: "Feedback Analysis Done",
    transitionToState: "CSAT Report Initiated",
    stateTransitionRemarks: "Direct reporting path",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:48",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:48",
  },
  {
    id: 20,
    transitionType: "Automatic",
    transitionFromState: "Rating Aggregation / Scorecard Initiated",
    transitionToState: "Rating Aggregation / Scorecard in Progress",
    stateTransitionRemarks: "Scorecard processing started",
    processName: "CSAT Program Management Process",
    clientName: "21st Century Financial Services", 
    active: "Yes",
    createdBy: "Sanjeev Kumar",
    createdDate: "18/03/26 12:49",
    lastUpdatedBy: "Sanjeev Kumar",
    lastUpdateDate: "18/03/26 12:49",
  },
];

  const loadSample = () => {
    setTransitions(demoTransitions);
  };

  const handleAddNew = () => {
    setEditingTransition(null);
    setFormData(initialForm);
    setShowModal(true);
  };

  const handleEdit = (trans) => {
    setEditingTransition(trans);
    setFormData({
      transitionType: trans.transitionType || "Manual",
      transitionFromState: trans.transitionFromState || "",
      transitionToState: trans.transitionToState || "",
      stateTransitionRemarks: trans.stateTransitionRemarks || "",
      processName: trans.processName || "",
      clientName: trans.clientName || "",
      active: trans.active || "Yes",
    });
    setShowModal(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this state transition? This action cannot be undone.")) return;
    setTransitions((prev) => prev.filter((t) => t.id !== id));
  };

  const handleOpenTransition = (trans) => {
    // Update this route as per your actual transition detail page
    navigate(`/processifyd-transitionhub/${trans.id}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.transitionFromState.trim() || !formData.transitionToState.trim() || !formData.processName.trim()) {
      alert("Transition From, Transition To, and Process Name are required.");
      return;
    }

    const newTransition = {
      id: editingTransition?.id || Date.now(),
      ...formData,
      createdBy: editingTransition?.createdBy || "Sanjeev Kumar",
      createdDate: editingTransition?.createdDate || new Date().toLocaleString("en-IN"),
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: new Date().toLocaleString("en-IN"),
    };

    if (editingTransition) {
      setTransitions((prev) =>
        prev.map((t) => (t.id === editingTransition.id ? newTransition : t))
      );
    } else {
      setTransitions((prev) => [...prev, newTransition]);
    }

    setShowModal(false);
    setFormData(initialForm);
  };

  // Filter + Pagination
  const filtered = transitions.filter(
    (t) =>
      t.transitionFromState.toLowerCase().includes(search.toLowerCase()) ||
      t.transitionToState.toLowerCase().includes(search.toLowerCase()) ||
      t.processName.toLowerCase().includes(search.toLowerCase()) ||
      t.clientName.toLowerCase().includes(search.toLowerCase()) ||
      t.stateTransitionRemarks.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const [showList, setShowList] = useState(false);
    
  const handleShowMyStateTransitions = async () => {
    try {
      setLoading(true);

      // 🔄 Replace this later with API call
      // const response = await axios.get("/api/statetransitions");
      // setTransitions(response.data);

      // ✅ Temporary Demo Data (remove later)
      setTransitions([]);

      setShowList(true);
    } catch (error) {
      console.error("Error fetching state transitions:", error);
    } finally {
      setLoading(false);
    }
  };

  const [showDiagram, setShowDiagram] = useState(false);

  const showSampleStateDiagram = () => {
    setShowDiagram(true);
  };

  const buildStateGraph = (transitions) => {
    const states = new Set();
    const edges = [];

    transitions.forEach((t) => {
      states.add(t.transitionFromState);
      states.add(t.transitionToState);

      edges.push({
        from: t.transitionFromState,
        to: t.transitionToState,
        type: t.transitionType,
      });
    });

    return { states: Array.from(states), edges };
  };

  // Simple BFS level layout
  const layoutStates = (states, edges) => {
    const levels = {};
    const visited = new Set();

    const start = edges[0]?.from;

    const queue = [{ state: start, level: 0 }];
    levels[start] = 0;

    while (queue.length) {
      const { state, level } = queue.shift();

      edges
        .filter((e) => e.from === state)
        .forEach((e) => {
          if (!visited.has(e.to)) {
            levels[e.to] = level + 1;
            queue.push({ state: e.to, level: level + 1 });
            visited.add(e.to);
          }
        });
    }

    // assign positions
    const positions = {};
    const levelMap = {};

    Object.entries(levels).forEach(([state, lvl]) => {
      if (!levelMap[lvl]) levelMap[lvl] = [];
      levelMap[lvl].push(state);
    });

    const X_GAP = 260;
    const Y_GAP = 140;

    Object.entries(levelMap).forEach(([lvl, arr]) => {
      arr.forEach((state, index) => {
        positions[state] = {
          x: lvl * X_GAP + 100,
          y: index * Y_GAP + 100,
        };
      });
    });

    return positions;
  };

  const getStateColor = (state) => {
    if (state.toLowerCase().includes("created")) return "#16a34a"; // green
    if (state.toLowerCase().includes("finished")) return "#0284c7"; // blue
    if (state.toLowerCase().includes("abandoned")) return "#dc2626"; // red
    return "#374151"; // gray
  };

  const StateDiagram = ({ transitions }) => {
    const { states, edges } = buildStateGraph(transitions);
    const positions = layoutStates(states, edges);

    const [scale, setScale] = React.useState(1);
    const [offset, setOffset] = React.useState({ x: 0, y: 0 });

    const svgRef = React.useRef(null);

    // const downloadDiagram = () => {
    //   const svg = svgRef.current;
    //   if (!svg) return;

    //   const serializer = new XMLSerializer();
    //   const source = serializer.serializeToString(svg);

    //   const svgBlob = new Blob([source], { type: "image/svg+xml;charset=utf-8" });
    //   const url = URL.createObjectURL(svgBlob);

    //   const img = new Image();
    //   img.onload = () => {
    //     const canvas = document.createElement("canvas");
    //     canvas.width = 2000;
    //     canvas.height = 1200;

    //     const ctx = canvas.getContext("2d");

    //     // white background (important for PNG)
    //     ctx.fillStyle = "#111827";
    //     ctx.fillRect(0, 0, canvas.width, canvas.height);

    //     ctx.drawImage(img, 0, 0);

    //     URL.revokeObjectURL(url);

    //     const imgURI = canvas
    //       .toDataURL("image/png")
    //       .replace("image/png", "image/octet-stream");

    //     const a = document.createElement("a");
    //     a.setAttribute("download", "state-machine.png");
    //     a.setAttribute("href", imgURI);
    //     a.click();
    //   };

    //   img.src = url;
    // };
    
    const downloadDiagram = () => {
      const svg = svgRef.current;
      if (!svg) return;

      const serializer = new XMLSerializer();
      let source = serializer.serializeToString(svg);

      // Fix namespace issue
      if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
        source = source.replace(
          /^<svg/,
          '<svg xmlns="http://www.w3.org/2000/svg"'
        );
      }

      const svgBlob = new Blob([source], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(svgBlob);

      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement("canvas");

        // ✅ Use actual SVG size (responsive fix)
        const bbox = svg.getBBox();
        canvas.width = bbox.width + 200;
        canvas.height = bbox.height + 200;

        const ctx = canvas.getContext("2d");

        // background
        ctx.fillStyle = "#111827";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // center drawing
        ctx.drawImage(img, 100, 100);

        URL.revokeObjectURL(url);

        const link = document.createElement("a");
        link.download = "state-machine.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      };

      img.src = url;
    };

    const isDragging = React.useRef(false);
    const last = React.useRef({ x: 0, y: 0 });

    const handleWheel = (e) => {
      e.preventDefault();
      const zoom = e.deltaY > 0 ? 0.9 : 1.1;
      setScale((s) => Math.min(Math.max(s * zoom, 0.5), 2));
    };

    const handleMouseDown = (e) => {
      isDragging.current = true;
      last.current = { x: e.clientX, y: e.clientY };
    };

    const handleMouseMove = (e) => {
      if (!isDragging.current) return;
      const dx = e.clientX - last.current.x;
      const dy = e.clientY - last.current.y;

      setOffset((prev) => ({
        x: prev.x + dx,
        y: prev.y + dy,
      }));

      last.current = { x: e.clientX, y: e.clientY };
    };

    const handleMouseUp = () => {
      isDragging.current = false;
    };

    return (
      <div className="mt-6 bg-gray-900 border border-gray-700 rounded-xl p-4">

        {/* Controls */}
        <div className="grid grid-cols-4 gap-1 place-items-center mb-2">
          {/* ✅ DOWNLOAD BUTTON (ADD HERE) */}
          <button
            onClick={downloadDiagram}
            className="flex items-center gap-2 px-3 py-1 bg-cyan-600 hover:bg-cyan-500 rounded text-sm"
          >
            <FontAwesomeIcon icon={faDownload} />
            Download State Machine
          </button>

          {/* Existing Controls */}
          <button
            onClick={() => setScale((s) => s * 1.2)}
            className="w-12 px-2 py-2 bg-gray-700 rounded"
          >
            +
          </button>

          <button
            onClick={() => setScale((s) => s * 0.8)}
            className="w-12 px-2 py-2 bg-gray-700 rounded"
          >
            -
          </button>

          <button
            onClick={() => {
              setScale(1);
              setOffset({ x: 0, y: 0 });
            }}
            className="tetx-xs lg:text-sm w-20 lg:w-32 px-2 py-2 bg-gray-700 rounded"
          >
            Reset
          </button>
        </div>

        {/* Responsive Container */}
        <div
          className="w-full h-[70vh] overflow-hidden cursor-grab"
          onWheel={handleWheel}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <svg
            ref={svgRef}
            viewBox="0 0 2000 1200"
            className="w-full h-full"
          >
            <g transform={`translate(${offset.x},${offset.y}) scale(${scale})`}>

              {/* Arrow Marker */}
              <defs>
                <marker
                  id="arrow"
                  markerWidth="10"
                  markerHeight="10"
                  refX="8"
                  refY="3"
                  orient="auto"
                >
                  <path d="M0,0 L0,6 L9,3 z" fill="#9ca3af" />
                </marker>
              </defs>

              {/* EDGES */}
              {edges.map((e, i) => {
                const from = positions[e.from];
                const to = positions[e.to];
                if (!from || !to) return null;

                return (
                  <line
                    key={i}
                    x1={from.x}
                    y1={from.y}
                    x2={to.x}
                    y2={to.y}
                    stroke={e.type === "Manual" ? "#f59e0b" : "#60a5fa"}
                    strokeWidth="2"
                    markerEnd="url(#arrow)"
                  />
                );
              })}

              {/* NODES */}
              {states.map((state, i) => {
                const pos = positions[state];
                if (!pos) return null;

                return (
                  <g key={i}>
                    <circle
                      cx={pos.x}
                      cy={pos.y}
                      r="42"
                      fill={getStateColor(state)}
                      stroke="#111827"
                      strokeWidth="2"
                    />

                    {/* Wrapped Text */}
                    <text
                      x={pos.x}
                      y={pos.y}
                      textAnchor="middle"
                      fill="white"
                      fontSize="10"
                      dy="0.35em"
                    >
                      {state.substring(0, 15)}
                    </text>
                  </g>
                );
              })}
            </g>
          </svg>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4 md:p-6">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-500/40 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-cyan-300">
            🔄 Processifyd
          </div>
          <div className="text-xs text-gray-400">
            State Transition Master
          </div>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-teal-300">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-12 px-2 py-1 bg-red-700/80 hover:bg-red-600 rounded-md text-sm"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-12 px-2 py-1 border border-teal-600 hover:bg-teal-900/30 rounded-md"
            >
              🔐
            </button>
          )}
        </div>

        <button
          className="md:hidden text-2xl text-cyan-300"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-4">
          {isLoggedIn && (
            <div className="flex flex-col items-center gap-4">
              <div className="text-teal-300">{userName}</div>
              <button onClick={handleLogout} className="w-12 px-2 py-1 bg-red-700 rounded-md">⏻</button>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[75vh]">
        {/* Controls */}
        <div className="mt-4 flex flex-col gap-4">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-1 place-items-center">
            <button
              onClick={loadSample}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              Load Sample Transitions
            </button>
            <button
              onClick={handleShowMyStateTransitions}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faList} />
              My State Transitions List
            </button>
            <button
              onClick={handleAddNew}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              New State Transition
            </button>      
            <button
              onClick={showSampleStateDiagram}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-64 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              Show Sample State Machine
            </button>     
          </div>

          <div className="relative w-full">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
            <input
              type="text"
              placeholder="Search by from/to state, process or remarks..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-cyan-500/60"
            />
          </div>
        </div>

        {showDiagram && (
          <StateDiagram transitions={demoTransitions} />
        )}

        {/* State Transition Cards */}
        <div className="mt-4 grid gap-4 grid-cols-1 lg:grid-cols-3">
          {paginated.map((trans) => (
            <div
              key={trans.id}
              className="bg-gray-800 border border-gray-700 rounded-xl p-5 hover:border-cyan-600/50 transition-colors group"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h3 className="font-semibold text-base text-white group-hover:text-cyan-300 transition-colors">
                    {trans.transitionFromState} → {trans.transitionToState}
                  </h3>
                  <div className="text-sm text-gray-400 mt-1">
                    {trans.transitionType} • In: <span className="text-cyan-300">{trans.processName}</span>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${trans.active === "Yes" ? "bg-emerald-600" : "bg-red-600"}`}>
                    {trans.active === "Yes" ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>
              <div className="text-sm text-gray-400 mt-1">
                {trans.clientName}
              </div>
              <p className="mt-4 text-sm text-gray-300 line-clamp-3">
                {trans.stateTransitionRemarks || "No remarks provided"}
              </p>

              <div className="mt-6 flex gap-2">
                <button
                  onClick={() => handleOpenTransition(trans)}
                  className="flex-1 py-2 bg-gradient-to-r from-cyan-700 to-teal-700 hover:from-cyan-600 hover:to-teal-600 rounded-lg font-medium flex items-center justify-center gap-2 text-sm"
                >
                  <FontAwesomeIcon icon={faFolderOpen} />
                  Open
                </button>

                <button
                  onClick={() => handleEdit(trans)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Edit Transition"
                >
                  <FontAwesomeIcon icon={faEdit} className="text-yellow-400" />
                </button>

                <button
                  onClick={() => handleDelete(trans.id)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Delete Transition"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-400" />
                </button>
              </div>
            </div>
          ))}

          {paginated.length === 0 && (
            <div className="col-span-full py-12 text-center text-gray-500">
              {search ? "No state transitions match your search" : "No state transitions yet. Click 'New State Transition' or 'Load Sample Transitions'"}
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <span className="text-sm">
              Page <strong>{currentPage}</strong> of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        )}

        {showList && (
          <div className="mt-4 bg-black text-white rounded-lg p-4">
            {loading ? (
              <p className="text-yellow-200">Loading state transitions...</p>
            ) : transitions.length === 0 ? (
              <p className="text-yellow-200">No state transitions found.</p>
            ) : (
              <ul className="space-y-2">
                {transitions.map((tra) => (
                  <li
                    key={tra}
                    className="border border-gray-700 rounded p-2"
                  >
                    <p className="font-semibold text-gray-100">{tra.transitionFromState} <span> - </span>
                    {tra.transitionToState}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* Add / Edit Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
            <div className="bg-gray-800 rounded-xl p-6 w-full max-w-2xl border border-gray-700 max-h-[92vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-cyan-300">
                  {editingTransition ? "Edit State Transition" : "New State Transition"}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-white w-12 text-2xl"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm mb-1.5">Transition Type</label>
                  <select
                    value={formData.transitionType}
                    onChange={(e) => setFormData({ ...formData, transitionType: e.target.value })}
                    className="w-full h-12 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg"
                  >
                    <option value="Manual">Manual</option>
                    <option value="Automatic">Automatic</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-1.5">Transition From This State <span className="text-red-400">*</span></label>
                    <input
                      required
                      value={formData.transitionFromState}
                      onChange={(e) => setFormData({ ...formData, transitionFromState: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                      placeholder="e.g. Rating Aggregation / Scorecard in Progress"
                    />
                  </div>

                  <div>
                    <label className="block text-sm mb-1.5">Transition To This State <span className="text-red-400">*</span></label>
                    <input
                      required
                      value={formData.transitionToState}
                      onChange={(e) => setFormData({ ...formData, transitionToState: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                      placeholder="e.g. Rating Aggregation / Scorecard Done"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm mb-1.5">State Transition Remarks</label>
                  <textarea
                    value={formData.stateTransitionRemarks}
                    onChange={(e) => setFormData({ ...formData, stateTransitionRemarks: e.target.value })}
                    rows={3}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="Description of this transition..."
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">Process Name <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.processName}
                    onChange={(e) => setFormData({ ...formData, processName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. CSAT Program Management Process"
                  />
                </div>
                <div>
                  <label className="block text-sm mb-1.5">Client <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.clientName}
                    onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. 21st Century Financial Services"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-1.5">Active <span className="text-red-400">*</span></label>
                    <select
                      value={formData.active}
                      onChange={(e) => setFormData({ ...formData, active: e.target.value })}
                      className="w-full h-12 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg"
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-8">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="px-6 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
                  >
                    {editingTransition ? "Update Transition" : "Create Transition"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-8">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="/about-us" className="hover:text-teal-300">About</a>
            <a href="/privacy-policy" className="hover:text-teal-300">Privacy Policy</a>
            <a href="/terms-of-use" className="hover:text-teal-300">Terms of Use</a>
            <a href="/contact-us" className="hover:text-teal-300">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydStateTransitions;